import React from "react"
import styles from "./styles.scss"
import ListItem from "components/ListItem"

class PreviousExperiences extends React.Component {
  render() {
    return (
      <section className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.textContainer}>
            <h2 className={styles.title}>
              Dina <span>meriterande</span> erfarenheter
            </h2>
            <b className={styles.description}>
              Om du tror att du är rätt person för jobbet, tveka inte att ansöka
              även om du inte uppfyller alla punkter nedan!
            </b>
            <ul className={styles.list}>
              {this.props.previousExperiences.map(task => (
                <ListItem key={task} text={task} className={styles.listItem} />
              ))}
            </ul>
          </div>
        </div>
      </section>
    )
  }
}

export default PreviousExperiences



// WEBPACK FOOTER //
// ./src/components/JobDescription/PreviousExperiences/index.jsx